// services/AdminServices/ConnectionService.ts

import { ConnectionModel, RequestResponseDTO, RequestResponseOutDTO } from "../../models/workFlow/ConnectionModel";
import { RequestType } from "../../models/workFlow/ExecutionFlowModel";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchConnections = async (
  accessToken: string,
  tenantId: number
): Promise<ConnectionModel[]> => {
  try {debugger;
    const endpoint = `${API_URL}${process.env.REACT_APP_GET_ALL_CONNECTIONS_API}?tenantId=${tenantId}`;

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch connections.");
    }

    const data = await response.json();
    console.log("Raw connection data:", data);

    const mappedConnections = mapToConnection(data);
    console.log("Mapped connection data:", mappedConnections);

    return mappedConnections;
  } catch (error) {
    console.error("Error in fetchConnections:", error);
    throw error;
  }
};

export const mapToConnection = (data: any | any[]): ConnectionModel[] => {
  const arr = Array.isArray(data) ? data : [data];
  return arr.map((item: any) => ({
    connectionId: item.connectionId,
    tenantId: item.tenantId,
    name: item.name,
    connectionType: item.connectionType,
    description: item.description,

    // API
    apiUrl: item.apiUrl,
    apiKey: item.apiKey,
    authType: item.authType,
    clientId: item.clientId,
    clientSecret: item.clientSecret,
    oAuthTokenUrl: item.oAuthTokenUrl,
    actionType: item.actionType,
    triggerType: item.triggerType,
    isSwaggerEnabled: item.isSwaggerEnabled,
    swaggerUrl: item.swaggerUrl,
    apiKeyHeaderName: item.apiKeyHeaderName,
    authPassword: item.authPassword,
    authUsername: item.authUsername,
    // DB
    dbServer: item.dbServer,
    dbName: item.dbName,
    dbUsername: item.dbUsername,
    dbPassword: item.dbPassword,
    dbPort: item.dbPort,
    dbType: item.dbType,

    // Audit
    createdAt: item.createdAt,
    createdBy: item.createdBy,
    updatedAt: item.updatedAt,
    updatedBy: item.updatedBy,
    isDeleted: item.isDeleted,
    deletedAt: item.deletedAt,
    deletedBy: item.deletedBy,
  }));
};

export const createConnection = async (
  accessToken: string,
  connectionData: ConnectionModel
): Promise<{ success: boolean; data?: ConnectionModel; message?: string }> => {
  try {

    console.log("JSON.stringify(connectionData) " , JSON.stringify(connectionData));
    const response = await fetch(`${API_URL}/api/Connection/CreateConnection`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
      body: JSON.stringify(connectionData),
    });

    const result = await response.json();

    if (response.ok) {
      return {
        success: true,
        data: result.data,
        message: result.message || "Connection created successfully",
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to create connection",
      };
    }
  } catch (error) {
    console.error("Error creating connection:", error);
    return {
      success: false,
      message: "An error occurred while creating the connection",
    };
  }
};

export const updateConnection = async (
  accessToken: string,
  connectionData: ConnectionModel
): Promise<{ success: boolean; data?: ConnectionModel; message?: string }> => {
  try {debugger;
    const response = await fetch(`${API_URL}/api/Connection/UpdateConnection`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
      body: JSON.stringify(connectionData),
    });

    const result = await response.json();

    if (response.ok) {
      return {
        success: true,
        data: result.data,
        message: result.message || "Connection updated successfully",
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to update connection",
      };
    }
  } catch (error) {
    console.error("Error updating connection:", error);
    return {
      success: false,
      message: "An error occurred while updating the connection",
    };
  }
};

export const deleteConnection = async (
  accessToken: string,
  connectionId: number,
  deletedBy: number,
  tenantId: number
): Promise<{ success: boolean; message?: string }> => {
  try {
    const body = {
      connectionIds: [connectionId], // send as array
      deletedBy: deletedBy,
      tenantID: tenantId,
    };

    const response = await fetch(`${API_URL}/api/Connection/DeleteConnection`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const result = await response.json();

    if (response.ok) {
      return {
        success: true,
        message: result.message || "Connection deleted successfully",
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to delete connection",
      };
    }
  } catch (error) {
    console.error("Error deleting connection:", error);
    return {
      success: false,
      message: "An error occurred while deleting the connection",
    };
  }
};



export const testConnection = async (
  accessToken: string,
  requestData: ConnectionModel
): Promise<{ success: boolean; message?: string; data?: any }> => {
  try {
    const response = await fetch(`${API_URL}/api/Connection/TestConnection`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();

    if (response.ok) {
      return {
        success: true,
        data: result.data,
        message: result.message || "Test connection succeeded",
      };
    } else {
      return {
        success: false,
        message: result.message || "Test connection failed",
      };
    }
  } catch (error) {
    console.error("Error testing connection:", error);
    return {
      success: false,
      message: "An error occurred while testing the connection",
    };
  }
};


export const fetchSwaggerEndPoint = async (
  accessToken: string,
  connectionId: number
): Promise<RequestType[]> => {
  try {
    const endpoint = `${API_URL}/api/Connection/GetRequestType?connectionId=${connectionId}`;

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch connections.");
    }

    const data = await response.json();
    console.log("Raw fetchSwaggerEndPoint :", data);

    const mappedConnections = mapToConnectionEndpoint(data.response);
    console.log("fetchSwaggerEndPointdata:", mappedConnections);

    return mappedConnections;
  } catch (error) {
    console.error("Error in fetchConnections:", error);
    throw error;
  }
};

export const mapToConnectionEndpoint = (data: any[]): RequestType[] => {
  return data.map((item: any) => ({
   type : item.type,
   name : item.name
  }));
};


export const fetchRequestResponse = async (
  accessToken: string,
  requestModel: RequestResponseDTO
): Promise<RequestResponseOutDTO> => {
  try {
    const endpoint = `${API_URL}/api/Connection/GetRequestResponse`;

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestModel),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch request response.");
    }

    const data = await response.json();
    console.log("Raw fetchRequestResponse:", data);

    return data.response as RequestResponseOutDTO;
  } catch (error) {
    console.error("Error in fetchRequestResponse:", error);
    throw error;
  }
};

export const fetchConnectionById = async (
  accessToken: string,
  connectionId: number
): Promise<ConnectionModel[]> => {
  try {
    const endpoint = `${API_URL}/api/Connection/GetConnectionById?connectionId=${connectionId}`;

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch connections.");
    }

    const data = await response.json();
    console.log("Raw connection data:", data);

    const mappedConnections = mapToConnection(data);
    console.log("Mapped connection data:", mappedConnections);

    return mappedConnections;
  } catch (error) {
    console.error("Error in fetchConnections:", error);
    throw error;
  }
};